import { render, staticRenderFns } from "./ApolloImageGallery.vue?vue&type=template&id=4f531ad3&"
import script from "./ApolloImageGallery.vue?vue&type=script&lang=js&"
export * from "./ApolloImageGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports